import React from "react";
import DocumentItem from "./DocumentItem";
import { classNames } from "src/helpers/classNames";

const DocumentEmbeded = ({ name = "", documents, className }) => {
  return (
    <div className={classNames("relative h-full w-full")}>
      <div className={classNames("mx-auto ", className)}>
        <div className="mb-12 bg-leftNavActiveColor py-10 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-leftNavActiveTextColor">{name || "Documents"}</h1>
        </div>
        <div className="grid grid-cols-1 gap-6 px-4 sm:grid-cols-2 md:grid-cols-3">
          {documents?.length > 0 ? (
            documents.map((doc) => (
              <DocumentItem
                key={doc._id}
                doc={doc}
              />
            ))
          ) : (
            <p className="col-span-full text-center text-gray-500">No documents available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentEmbeded;
